<script setup lang="ts">
import { computed, inject } from 'vue';
import { EXTENSION_OF_TIME_DOC_CTX } from '../extensionOfTimeContext';
import SignersField from '../../resignation/signers/SignersField.vue';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

const props = withDefaults(defineProps<{ varKey?: string; boardLabel?: string }>(), {
  varKey: 'dcr',
  boardLabel: '',
});
const ctx = inject(EXTENSION_OF_TIME_DOC_CTX)!;
const signers = computed(() => ctx.signersOf(props.varKey));
function onUpdate(list: SignerEntry[]) { ctx.setSigners(props.varKey, list); }
</script>

<template>
  <SignersField
    :model-value="signers"
    :board-label="boardLabel"
    :var-key="varKey"
    :entity-cd="ctx.entityCd.value"
    @update:model-value="onUpdate"
  />
</template>
